
import { Component, Vue } from 'vue-property-decorator';
import { LocationModel } from '@/services/api.service';

import { latLng } from 'leaflet';
import {LMap, LTileLayer, LMarker, LPopup } from 'vue2-leaflet';
import { Location } from 'vue-router';


@Component({
    props: {
        locations: {
          type: Array as () => LocationModel[],
          required: true
        },
        zoomLevel: {
          type: Number,
          required: false,
          default: 13
        },
        autoCenter: {
          type: Boolean,
          required: false,
          default: false
        }
    },
    components: {
        LMap,
        LTileLayer,
        LMarker,
        LPopup
    }
})
export default class LocationsMap extends Vue {

  private url: string = 'https://{s}.tile.osm.org/{z}/{x}/{y}.png';
  private attribution: string = '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors';
  private zoom: number = 13;
  private center: any = latLng(-37.615669, 144.944433);
  private centerIsDefault: boolean = true;
  private currentZoom: number = 11.5;
  private currentCenter: any = latLng(-37.615669, 144.944433);

  private homeMarker: any = latLng(-37.615669, 144.944433);

  private mounted() {
    // center on the first location
    this.zoom = this.$props.zoomLevel;
    
    
    if (this.$props.locations !== undefined && this.$props.locations.length > 0) {
      this.center = this.getLatLng(this.$props.locations[0]);
      this.centerIsDefault = false;
    }
  }

  private zoomUpdate(zoom: number) {
    this.currentZoom = zoom;
  }
  
  private centerUpdate(center: any) {
    this.currentCenter = center;
  }
  
  private setCenter(newCenter: any) {
    const mapComponent: any = this.$refs.locMap;
    // @ts-ignore
    if (mapComponent !== undefined && mapComponent.mapObject !== undefined) {
      mapComponent.mapObject.setView(newCenter, this.zoom);
    }
  }
  private getLatLng(loc: LocationModel): any {
    // determine the best lat long to use for the location
    // either by the lat long vlaues, or the postcode center point
    const locLatLng: any = latLng(loc.latitude!, loc.longitude!);
    if (this.$props.autoCenter) {
      this.setCenter(locLatLng);
    }
    if (this.centerIsDefault) {
      this.center = locLatLng;
      this.centerIsDefault = false;
    }
    return locLatLng;
  }

}
